import { render, staticRenderFns } from "./requestrefund.vue?vue&type=template&id=15ca64a6&"
import script from "./requestrefund.vue?vue&type=script&lang=js&"
export * from "./requestrefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports